import * as React from "react";
import CenteredSpinner from "../../components/CenteredSpinner";
import SidebarList from "./components/SidebarList";

const Sidebar = ({ children, onItemSelected, isLoadingMoreItems }) => (
  <div style={{ display: "flex", justifyContent: "space-around" }}>
    <SidebarList
      children={children}
      onItemSelected={index => onItemSelected(index)}
    />
    {isLoadingMoreItems && <CenteredSpinner />}
  </div>
);

export default Sidebar;
